

import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import { toast } from 'react-toastify';
import EventModal from './EventModal';
import Swal from 'sweetalert2';

const Event = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);

    const [image, setImage] = useState("");
    const [preImage, setPreImage] = useState("");
    const url = process.env.REACT_APP_LINK
    const token = localStorage.getItem("token") || ""
    const [data, setData] = useState({
        img: "",
        title: "",
        short_description: "",
        description: "",
        price: "",
        join_fee: "",
        win_amount: "",
        watch_amount: "",
        start_time: "", end_time: ""
    })
    const [loading, setLoading] = useState(false);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/event`);
            const data = await response.json();
            setEmployees(data.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreImage(URL.createObjectURL(file));
            setImage(file);
        }
    };

    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        const isEdit = data.id !== undefined;
        const urlmain = isEdit
            ? `${url}/api/event/${data.id}`
            : `${url}/api/event`;
        const method = isEdit ? "PUT" : "POST";


        try {
            // prepare FormData
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("description", data.description || "");
            formData.append("price", data.price || "");
            formData.append("join_fee", data.join_fee);
            formData.append("win_amount", data.win_amount);
            formData.append("short_description", data.short_description);
            formData.append("watch_amount", data.watch_amount);
            formData.append("start_time", data.start_time);
            formData.append("end_time", data.end_time);

            // assuming you keep image in separate useState
            if (image) {
                formData.append("image", image); // backend field name must match
            }

            const res = await fetch(urlmain, {
                method,
                body: formData, // no need for headers (browser sets it automatically with boundary)
            });

            const result = await res.json();

            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    image: result.image,
                    title: result.title,
                    description: result.description,
                    price: result.price,
                    join_fee: result.join_fee,
                    win_amount: result.win_amount,
                    watch_amount: result.watch_amount,
                    start_time: result.start_time,
                    end_time: result.end_time
                };

                toast.success(isEdit ? "Event updated" : "Event added");

                fetchUsers();
                setIsModalOpen(false);

                setData({
                    img: "",
                    title: "",
                    description: "",
                    price: "",
                    join_fee: "",
                    win_amount: "",
                    watch_amount: "",
                    start_time: "",
                    end_time: ""
                });
                setImage(null);
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err);
        } finally {
            setLoading(false)
        }
    };

    const handleDelete = (email) => {
        const updatedEmployees = employees.filter(employee => employee.email !== email);
        setEmployees(updatedEmployees);
    };

    const handleComplete = async (id) => {
        // Step 1: Show confirmation dialog
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to mark this submission as complete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, complete it!"
        });

        if (result.isConfirmed) {
            try {
                // Step 2: Send request to backend
                const response = await fetch(`${url}/api/event/status/complete/${id}`, {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        eventStatus: true
                    })
                });

                const res = await response.json();

                if (response.ok) {
                    Swal.fire("Completed!", res.message || "Submission marked as complete.", "success");

                    // Optionally, update state to reflect completion
                    const updatedEmployees = employees.map(emp =>
                        emp.id === id ? { ...emp, status: "Complete" } : emp
                    );
                    setEmployees(updatedEmployees);
                } else {
                    Swal.fire("Error!", res.error || "Something went wrong.", "error");
                }
            } catch (error) {
                console.error(error);
                Swal.fire("Error!", "Something went wrong.", "error");
            }
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">All Event</h1>
                    {currentData.length === 0 &&
                        <button className="oms-add-btn" onClick={() => {
                            setIsModalOpen(true)
                            setData({
                                img: "",
                                title: "",
                                description: "",
                                price: "",
                                join_fee: "",
                                win_amount: "",
                                watch_amount: "",
                                start_time: "",
                                end_time: ""
                            });
                        }}>
                            Add Event
                        </button>
                    }
                </div>
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                {/* <th>Event</th> */}
                                <th>Title</th>
                                <th>Short Description</th>
                                <th>Price</th>
                                <th>Join Fee</th>
                                <th>Winning Amount</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        {/* <td>
                                            <button onClick={() => handleComplete(employee.id)} style={{ background: "#002c52", color: "white" }} className="newcomplete-button">
                                                <i class="fa-solid fa-check"></i>
                                            </button>
                                        </td> */}

                                        <td>{employee.title}</td>
                                        <td>
                                            {/* <div
                                                className="releases-description-cell"
                                                dangerouslySetInnerHTML={{ __html: employee.description }}
                                            /> */}
                                            {employee.short_description}
                                        </td>


                                        <td>{employee.join_fee}</td>
                                        <td>{employee.price}</td>
                                        <td>{employee.win_amount}</td>

                                        <td>{new Date(employee.createdAt).toLocaleString()}</td>
                                        <td>
                                            <button className="edit-button"
                                                onClick={() => {
                                                    setPreImage(employee.image)
                                                    setData({
                                                        id: employee.id, // include ID for PUT request
                                                        image: employee.image,
                                                        title: employee.title || "",
                                                        short_description: employee.short_description || "",
                                                        description: employee.description || "",
                                                        join_fee: parseInt(employee.join_fee, 10),
                                                        price: parseInt(employee.price, 10),
                                                        win_amount: parseInt(employee.win_amount, 10),
                                                        watch_amount: parseInt(employee.watch_amount, 10),
                                                        start_time: employee.start_time,
                                                        end_time: employee.end_time
                                                    });

                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            {/* <button className="delete-button">
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button> */}
                                        </td>
                                        {/* <td>
                                            <button onClick={() => handleDelete(employee.email)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>
            <EventModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={data}
                image={image}
                preImage={preImage}
                setCouponForm={setData}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
                handleThumbnailChange={handleThumbnailChange}
                setData={setData}
                loading={loading}
            />
        </>
    );
};

export default Event;
